<div class="panel" [ngClass]="{ 'panel-bordered': border, 'panel-compact': compact }">
  <span *ngIf="title" class="label">{{ title }}</span>
  <button type="button" class="value" [disabled]="disabled" (click)="open()">
    {{ label(display) }}
  </button>
</div>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="picker">
      <ion-picker>
        <!-- Only the number scrolls; "minutes" is a static suffix Ionic aligns to the selection line. -->
        <ion-picker-column
          [value]="selected"
          (ionChange)="onColumnChange($event)"
        >
          <!-- Visual is number-only; screen readers get the full "N minute(s)" via aria-label. -->
          <ion-picker-column-option *ngFor="let m of options" [value]="m" [attr.aria-label]="label(m)">
            {{ m }}
          </ion-picker-column-option>
          <div slot="suffix" class="unit">minutes</div>
        </ion-picker-column>
      </ion-picker>

      <div class="button" (click)="onApply()">Set</div>
    </div>
  </ng-template>
</ion-modal>
